import Step from "./Step";

class Step8 extends Step {
    constructor() {
        super(9, 'confirm_demo', $(`[data-register-step="confirm_demo"]`));

        this.demoSummary = this.element.find('#demo_summary');
        this.changeDatetimeBtn = this.element.find('#change_datetime_btn');
        this.demoNotes = this.element.find('#demo_notes');
        this.backButton = this.element.find('#back_to_scheduler');
        this.confirmButton = this.element.find('#confirm_demo_btn');
    }

    init() {
        console.log('Step8 init: Confirm demo');
        this.renderSummary();
        this.attachEventHandlers();
    }

    renderSummary() {
        const demoData = window.register?.demoData;
        if (!demoData || !demoData.timeSlot) {
            this.demoSummary.text('Selecteer eerst een datum en tijd');
            return;
        }

        const dateObj = new Date(demoData.timeSlot.datetime);
        const formattedDate = dateObj.toLocaleDateString('nl-NL', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
        });
        const formattedTime = dateObj.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
        this.demoSummary.text(`${formattedDate} om ${formattedTime}`);
    }

    attachEventHandlers() {
        this.changeDatetimeBtn.off('click').on('click', (e) => {
            e.preventDefault();
            this.goToStep('scheduler');
        });

        this.backButton.off('click').on('click', (e) => {
            e.preventDefault();
            this.goToStep('scheduler');
        });

        this.confirmButton.off('click').on('click', (e) => {
            e.preventDefault();
            this.confirmDemo();
        });
    }

    async confirmDemo() {
        const demoData = window.register?.demoData;
        if (!demoData || !demoData.timeSlot) {
            message.error('Selecteer eerst een datum en tijd');
            this.goToStep('scheduler');
            return;
        }

        this.confirmButton.attr('data-kt-indicator', 'on');

        try {
            const requestData = {
                scheduled_at: demoData.timeSlot.datetime,
                notes: this.demoNotes.val() || '',
            };
            if (demoData.existingDemo?.id) {
                requestData.demo_id = demoData.existingDemo.id;
            }

            const response = await API.post('/demo/schedule', requestData);

            if (response.status === 'success') {
                message.success('Demo is succesvol ingepland!');
                this.goToStep('congrats');
            } else {
                message.error(response.message || 'Er is een fout opgetreden bij het inplannen van de demo.');
            }
        } catch (error) {
            console.error('Step8: Failed to schedule demo', error);
            const errorMessage = error?.responseJSON?.message || 'Er is een fout opgetreden bij het inplannen van de demo.';
            message.error(errorMessage);
        } finally {
            this.confirmButton.attr('data-kt-indicator', 'off');
        }
    }
}

export default Step8;
